import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from "@angular/router";
import { constants } from "../../../utils/constants";
import { AuthService } from "src/app/services/auth.service";
import { IErrorAlert } from "src/app/interfaces/error.interface";
import { ICredentials } from "src/app/interfaces/credentials.interface";
import helpers from "src/app/utils/helpers";

@Component({
  selector: "app-login-executive",
  templateUrl: "./login-executive.component.html",
  styleUrls: ["../../auth.styles.css"],
})
export class LoginExecutiveComponent implements OnInit {
  constants: any = constants;
  helpers = helpers;
  loading: boolean = false;
  capslockOn: boolean;
  countLogin: number = 0;
  executiveForm: FormGroup;

  error: IErrorAlert = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public _auth: AuthService
  ) {}

  
  ngOnInit() {
    this.executiveForm = this.fb.group({
      ruc: [
        "",
        [
          Validators.required,
          Validators.pattern(constants.validations.numeric.pattern),
          Validators.minLength(11),
        ],
      ],
      user_company: [
        "",
        [
          Validators.required,
          Validators.pattern(constants.validations.loginExecutive.alphabetic.pattern),
          Validators.minLength(6),
          Validators.maxLength(60),
        ],
      ],
      password: [
        "",
        [
          Validators.required,
          Validators.pattern(
            constants.validations.loginExecutive.alphanumeric.pattern
          ),
          Validators.minLength(8),
          Validators.maxLength(20),
        ],
      ],
    });
    this.helpers.initFormListeners(this.executiveForm);
  }

 

  login() {
    this.error = null;
    this.loading = true;
    const credentials: ICredentials = {
      ruc: this.executiveForm.controls["ruc"].value,
      companyUser: this.executiveForm.controls["user_company"].value,
      password: this.executiveForm.controls["password"].value,
    };

    this._auth.login(credentials, "EJECUTIVO").subscribe(
      () => this.router.navigate(["pages/home/executive"]),
      (err: IErrorAlert) => {
       
        if(this.countLogin < 5 && (err.code == 500 || err.code == 400)){
          this.countLogin++;
          this.login();

        }else{
          this.countLogin = 0;
          this.error = err;
          this.loading = false;

        }
               
      }
    );
  }

  anyAlert() {
    return (
      this.capslockOn ||
      ((helpers.invalidControl(this.executiveForm.get("ruc")) &&
        !this.executiveForm.get("ruc").errors.required)) 
      ||
      this.error
    );
  }

  public patternMail = {
    "0": { pattern: new RegExp("^[a-zA-Z_]$") },

  };



}
